import { useCallback, useEffect, useState } from "react";
import {
  isOnboardingCompleted,
  markOnboardingCompleted,
  onboardingAudit,
} from "@/lib/onboarding";

/**
 * Drives the first-time Tactical Quick Start Guide.
 * - Auto-opens on first visit (after a short delay so the radar mounts first).
 * - Exposes `open()` for the Help button to reopen on demand.
 */
export function useOnboarding() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isOnboardingCompleted()) markOnboardingCompleted();
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
    onboardingAudit.reopened();
  }, []);

  const close = useCallback((reason: "completed" | "skipped", lastStep = 0) => {
    setIsOpen(false);
    markOnboardingCompleted();
    if (reason === "completed") onboardingAudit.completed();
    else onboardingAudit.skipped(lastStep);
  }, []);

  return { isOpen, open, close };
}